module.exports = __webpack_public_path__ + "static/media/seaplaneport.7d8c5e80.svg";